// extracted by mini-css-extract-plugin
module.exports = {"titleMobile":"styles_titleMobile__3mZrk"};